import { render, staticRenderFns } from "./ReturnTitle.vue?vue&type=template&id=0754662b&scoped=true&"
import script from "./ReturnTitle.vue?vue&type=script&lang=js&"
export * from "./ReturnTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754662b",
  null
  
)

export default component.exports